const updateFrequencyStr = {
  toastr: 'Periodicidad actualizada',
  toastr1: 'fue actualizada con éxito',
  toastrError: 'Periodicidad ya registrada',
  toastrError1: 'Ingrese otro nombre'
};

export default updateFrequencyStr;
